import { gql } from 'graphql-request';

export const CACHE_CREATE_STRIPE_ATTEMPT_QUERY = gql`
  mutation CacheCreateStripeAttempt(
    $invoiceId: ID!
    $withPaymentUrl: Boolean
    $withSessionClientSecret: Boolean
  ) {
    createStripeAttempt(
      input: {
        invoiceId: $invoiceId
        withPaymentUrl: $withPaymentUrl
        withSessionClientSecret: $withSessionClientSecret
      }
    ) {
      appVersion
      errors {
        fullMessages
      }
      record {
        id
        paymentUrl
        sessionClientSecret
      }
      recordId
      status
    }
  }
`;
